export default {
	title: 'Enjeux',
	url: 'enjeux',
	no_description: 'Aucun objectif défini',
	context_worse: 'Négatif',
	context_best: 'Positif',
	tabs: {
		filters: {
			title: 'Filtres'
		},
		general: {
			title: 'Général'
		},
		export: {
			title: 'Exporter'
		},
		comments: {
			title: 'Historique'
		},
		bot: {
			title: 'IA'
		}
	},
	messages: {
		edit_stake: "Édition de l'enjeu",
		create_stake: 'Créer un nouvel enjeu'
	},
	onboarding: {
		title: 'Revue des enjeux',
		description:
			"L'IA a identifié les enjeux structurants de votre sujet. Vérifiez qu'ils représentent bien ce que vous risquez de perdre ou de gagner si rien n'est fait. Ajustez, supprimez ou complétez si besoin."
	}
};
